import IconV2 from '@/components/v2/IconV2.jsx';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import selectors from '@/redux/selectors/selectors';
import statusIconMap from '@/schema/statusIconMap.jsx';
import parseError from '@/screens/home/lib/parseError.jsx';
import { useCallback } from 'react';

const statusTitleMap = (status) => ({ error: 'Error', warn: 'Warning' })[status || 'error'];

const LogOperationRow = ({ item, onView, onDismiss }) => {
  const activeLogId = useArgSelector(query, 'logId');
  const output = useArgSelector(selectors.workflowLogOutputById, activeLogId);

  const getStepNumber = useCallback(
    (log) => {
      const step = output?.meta?.steps?.find((n) => n?.id === log?.stepId);
      return step?.stepNumber;
    },
    [output]
  );

  return (
    <div className="row" onClick={() => onView(item)}>
      <div className="left">
        <div className={'step-number'}>{getStepNumber(item)}</div>
        <IconV2 icon={statusIconMap(item?.actionStatus)} variant={`status-${item?.actionStatus}`} title={statusTitleMap(item?.actionStatus)} />
        <p>{parseError(item?.meta?.error?.message) || parseError(item?.meta?.warning?.message) || item?.message}</p>
      </div>
    </div>
  );
};

export default LogOperationRow;
